"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsStyledWrapper = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../utils");
var p = utils_1.createPrefixer("wh-UI-TabsStyledWrapper-");
var classes = {
    content: p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["cotent"], ["cotent"]))),
    navWhite: p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["nav-white"], ["nav-white"]))),
};
var StyledWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: white;\n  .ant-tabs {\n    overflow: visible;\n  }\n  .ant-tabs-nav {\n    background: whitesmoke;\n    padding: 0px 1rem;\n    margin: 0px;\n  }\n\n  .", " {\n    padding: 1rem;\n  }\n\n  .", " {\n    .ant-tabs-nav {\n      background: white;\n    }\n  }\n"], ["\n  background: white;\n  .ant-tabs {\n    overflow: visible;\n  }\n  .ant-tabs-nav {\n    background: whitesmoke;\n    padding: 0px 1rem;\n    margin: 0px;\n  }\n\n  .", " {\n    padding: 1rem;\n  }\n\n  .", " {\n    .ant-tabs-nav {\n      background: white;\n    }\n  }\n"])), classes.content, classes.navWhite);
var TabsStyledWrapper = function (_a) {
    var children = _a.children;
    return react_1.default.createElement(StyledWrapper, null, children);
};
exports.TabsStyledWrapper = TabsStyledWrapper;
TabsStyledWrapper.classes = classes;
var templateObject_1, templateObject_2, templateObject_3;
/* styled end. */
